export default __webpack_public_path__ + "static/media/emotion-s@2x.ef181878.png";